/**
 * weather — part of the German catalogue (the reference language).
 * Merged in `i18n/de.ts`; every key here must exist in `i18n/en/weather.ts`.
 */

export const weather = {
  /* ATIS */
  'atis.station': 'Station und Frequenz',
  'atis.code': 'Code',
  'atis.rwy': 'Startbahn',
  'atis.tl': 'Übergangsfläche (TL)',
  'atis.zeit': 'Zeit UTC',
  'atis.wind': 'Wind',
  'atis.sicht': 'Sicht',
  'atis.wolken': 'Wolken',
  'atis.temp': 'Temperatur/Taupunkt',
  'atis.qnh': 'QNH',
  'atis.tendenz': 'Tendenz/weitere Information',

  /* ---------------- METAR / TAF (ATIS-Zeilen und Wetter-Beratung) ---------------- */
  'wx.nostations':
    'Keine Station: „von“, „nach“ oder „Ausweichflugplatz“ als ICAO-Code eintragen (z. B. LJLJ).',
  'wx.hint':
    'Aus dem METAR übernommen. Code, Bahn und TL stehen nur im ATIS.',
  'wx.status.metar': 'METAR {id} {time}',
  'wx.status.taf': 'TAF gültig bis {time}',
  'wx.status.tafOf': 'TAF {id} gültig bis {time}',
  'wx.unavailable': 'Für {ids} gibt es gerade keine Meldung – es gilt, was im Formular steht.',
  'wx.noroom': 'Beide ATIS-Zeilen belegt – {ids} fehlt. Eine Zeile leeren.',
  'wx.nometar': 'keine Wettermeldung für {id} – dieser Platz meldet nicht.',
  'wx.nometar.brief': 'Amtliche Beratung:',
  'wx.nometar.generic':
    'keine Wettermeldung für {id} – dieser Platz meldet nicht. Amtliche Beratung beim nationalen Flugwetterdienst.',
  'wx.raw': 'Rohtext METAR/TAF',
  'wx.take.full': 'Kein Platz: {lines} passt nicht mehr in die sechs Zeilen. Eine Zeile leeren.',
  'wx.field.derived': 'aus dem Wetter {id}',

  /* ---- die nächste Station, die meldet (GET /api/wx/nearby) ---- */
  'wx.nearby.head': 'nächste Meldung: {station} — {dist} NM {dir} von {of}',
  'wx.nearby.status': 'kein METAR für {of} · nächste Meldung {station} {dist} NM {dir}',
  // Prosa, die auf das ausgedruckte Formblatt kommt — wie die Bemerkung eines
  // Meldepunkts in der Sprache der Oberfläche geschrieben, zum Zeitpunkt des Schreibens.
  'wx.nearby.cell': '{id} ({dist} NM von {of})',
  'wx.nearby.taken': 'In ATIS-Zeile {row}: {id}, nicht {of}.',
  'wx.nearby.noroom': 'Keine ATIS-Zeile frei. Eine Zeile leeren.',
  'wx.nearby.own': '{id} steht schon mit eigener Zeile im Formblatt.',
  'wx.nearby.busy': 'suche nächstgelegene Meldung …',
  'wx.dir.n': 'N',
  'wx.dir.ne': 'NO',
  'wx.dir.e': 'O',
  'wx.dir.se': 'SO',
  'wx.dir.s': 'S',
  'wx.dir.sw': 'SW',
  'wx.dir.w': 'W',
  'wx.dir.nw': 'NW',
  'wx.cat.vfr': 'VFR — Untergrenze ≥ 3.000 ft und Sicht ≥ 8 km',
  'wx.cat.mvfr': 'MVFR — Untergrenze 1.000–3.000 ft oder Sicht 5–8 km',
  'wx.cat.ifr': 'IFR — Untergrenze 500–1.000 ft oder Sicht 1,6–5 km',
  'wx.cat.lifr': 'LIFR — Untergrenze < 500 ft oder Sicht < 1,6 km',
  'wx.taf.periods': 'TAF-Zeitabschnitte – Einstufung VFR/MVFR/IFR, keine VMC-Prüfung:',
  'wx.taf.visib': 'Sicht {v}',
  'wx.taf.visib.min': 'Sicht ≥ {v}',
  'wx.taf.ceiling': 'Untergrenze {ft} ft',

  'wx.pane.title': 'Wetter',

  /* ---------------- die Wetter-Ansicht (panes/weather) ---------------- */
  'wx.decoded.title': 'Aus dem METAR entschlüsselt',
  'wx.row.wind': 'Wind',
  'wx.row.sicht': 'Sicht',
  'wx.row.wolken': 'Wolken',
  'wx.row.temp': 'Temp./Taup.',
  'wx.row.qnh': 'QNH',
  'wx.row.tendenz': 'Tendenz',
  'wx.role.von': 'Von',
  'wx.role.nach': 'Nach',
  'wx.role.alt': 'Ausweich',
  'wx.empty.title': 'Kein Platz eingetragen.',
  'wx.empty.line': '„Von“ und „Nach“ als ICAO-Code eintragen – das Wetter kommt dann von selbst.',
  'wx.card.pending': 'Wetter wird geholt …',
  'wx.card.unavailable': 'Gerade keine Meldung – es gilt, was hier steht.',
  'wx.card.atisrow': 'In ATIS-Zeile {n}',
  'wx.nometar.here': 'Dieser Platz meldet kein Wetter.',
  'wx.nearby.title': 'Nächste Meldung',
  'wx.nearby.dist': '{dist} NM {dir} von {of}',
  'wx.taf.valid': 'gültig bis {time}',
  'wx.taf.ateta': 'Bei Ankunft {time}',
  'wx.tick.etd': 'Start',
  'wx.tick.eta': 'Ankunft',
  'wx.sun.title': 'Tageslicht',
  'wx.sun.eta': 'Ankunft {time}',
  'wx.sun.ss': 'Sonnenuntergang {time}',
  'wx.sun.left': 'noch {span} Tageslicht',
  'wx.sun.after': '{span} nach Sonnenuntergang',
} as const;
